const scrollToError = (key: string) => {
  const element = document.querySelector(`*[name=${key}]`);
  if (element) element.scrollIntoView({ block: 'center' });
};

export default scrollToError;
